export enum Colourway {
  grayBlue = 1,
  grayOrange = 2
}
